/*@flow*/
import React from 'react';
import AsyncDropdown from 'comps/AsyncDropdown';
import type { LocalsT } from 'lib/proforma/types';
import select from 'lib/proforma/templates/Select';

type PropsT = {
  isMulti: boolean,
  name?: string,
  loadValues?: (input?: string) => Promise<any[]>,
  loadOptions?: (input?: string) => Promise<any[]>,
};

export default (props: PropsT): any =>
  select.clone({
    Select: (locals: LocalsT) => {
      const {
        onChange,
        attrs,
        noOptionsMessage,
        value,
        extraProps = {},
      } = locals;
      let { placeholder } = attrs || {};
      const mergedProps = { ...{ ...props, ...extraProps } };

      return (
        <AsyncDropdown
          {...mergedProps}
          noOptionsMessage={noOptionsMessage}
          value={value}
          placeholder={placeholder}
          onChange={(v: any | any[]) => {
            if (Array.isArray(v) && mergedProps.isMulti === false) {
              onChange(v[v.length - 1]);
            } else {
              onChange(v);
            }
          }}
        />
      );
    },
  });
